import { useRouteError } from "react-router-dom";
import { buttonClass } from "@/components/base/buttonStyles";
import { isChunkLoadError } from "@/router/lazyRoute";

/**
 * 라우트에서 예외가 났을 때 보여 주는 화면.
 *
 * 이게 없으면 react-router 의 기본 오류 화면(영문 스택 + "Hey developer" 안내)이 그대로
 * 사용자에게 노출된다. 담당자·기사 어느 쪽에도 보여선 안 되는 화면이라 한국어 안내로 덮는다.
 *
 * 새 배포로 청크가 사라진 경우는 `lazyRoute` 가 먼저 자동 새로고침으로 처리한다.
 * 여기까지 왔다는 것은 새로고침 직후에 또 실패했다는 뜻이라 사유를 나눠 안내한다.
 */
export default function RouteError() {
  const error = useRouteError();
  const stale = isChunkLoadError(error);
  const detail = error instanceof Error ? error.message : String(error ?? "");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 px-6">
      <p className="text-sm text-gray-900">
        {stale
          ? "새 버전이 배포되어 화면을 다시 받아야 합니다."
          : "화면을 여는 중 문제가 생겼습니다."}
      </p>
      <p className="max-w-md text-center text-xs leading-relaxed text-gray-500">
        {stale
          ? "새로고침하면 최신 화면으로 이어집니다. 계속 같은 안내가 나오면 네트워크 상태를 확인해 주세요."
          : "새로고침해도 같은 화면이 나오면 아래 내용을 담당자에게 전달해 주세요."}
      </p>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className={buttonClass("primary")}
        >
          새로고침
        </button>
        <a href="/" className={buttonClass("secondary")}>
          처음으로
        </a>
      </div>

      {!stale && detail && (
        <pre className="max-w-xl overflow-x-auto whitespace-pre-wrap break-all border border-gray-200 p-3 text-xs text-gray-400">
          {detail}
        </pre>
      )}
    </div>
  );
}
